// IPA symbol → tooltip data
// basic mode: English word example { word, bold } where bold is the letter(s) representing the sound
// advanced mode: Full phonetic description
//
// Sources: IPA Handbook, Ladefoged & Johnson "A Course in Phonetics"

const IPA_TOOLTIPS = {
  // ── Pulmonic Consonants ──

  // Plosives
  'p':  { example: { word: 'pat',    bold: 'p' },  description: 'Voiceless bilabial plosive' },
  'b':  { example: { word: 'bat',    bold: 'b' },  description: 'Voiced bilabial plosive' },
  't':  { example: { word: 'tap',    bold: 't' },  description: 'Voiceless alveolar plosive' },
  'd':  { example: { word: 'dog',    bold: 'd' },  description: 'Voiced alveolar plosive' },
  'ʈ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiceless retroflex plosive' },
  'ɖ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced retroflex plosive' },
  'c':  { example: { word: 'cute',   bold: 'c' },  description: 'Voiceless palatal plosive' },
  'ɟ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced palatal plosive' },
  'k':  { example: { word: 'cat',    bold: 'c' },  description: 'Voiceless velar plosive' },
  'ɡ':  { example: { word: 'go',     bold: 'g' },  description: 'Voiced velar plosive' },
  'q':  { example: { word: '(none in English)', bold: '' }, description: 'Voiceless uvular plosive' },
  'ɢ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced uvular plosive' },
  'ʔ':  { example: { word: 'uh-oh',  bold: '-' },  description: 'Glottal stop' },

  // Nasals
  'm':  { example: { word: 'map',    bold: 'm' },  description: 'Voiced bilabial nasal' },
  'ɱ':  { example: { word: 'symphony', bold: 'm' }, description: 'Voiced labiodental nasal' },
  'n':  { example: { word: 'nap',    bold: 'n' },  description: 'Voiced alveolar nasal' },
  'ɳ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced retroflex nasal' },
  'ɲ':  { example: { word: 'canyon', bold: 'ny' },  description: 'Voiced palatal nasal' },
  'ŋ':  { example: { word: 'sing',   bold: 'ng' }, description: 'Voiced velar nasal' },
  'ɴ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced uvular nasal' },

  // Trills
  'ʙ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced bilabial trill' },
  'r':  { example: { word: 'run (Scottish)', bold: 'r' }, description: 'Voiced alveolar trill' },
  'ʀ':  { example: { word: '(French r)', bold: 'r' }, description: 'Voiced uvular trill' },

  // Taps / Flaps
  'ⱱ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced labiodental flap' },
  'ɾ':  { example: { word: 'butter (AmE)', bold: 'tt' }, description: 'Voiced alveolar tap' },
  'ɽ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced retroflex flap' },

  // Fricatives
  'ɸ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiceless bilabial fricative' },
  'β':  { example: { word: '(Spanish cabo)', bold: 'b' }, description: 'Voiced bilabial fricative' },
  'f':  { example: { word: 'fan',    bold: 'f' },  description: 'Voiceless labiodental fricative' },
  'v':  { example: { word: 'van',    bold: 'v' },  description: 'Voiced labiodental fricative' },
  'θ':  { example: { word: 'think',  bold: 'th' }, description: 'Voiceless dental fricative' },
  'ð':  { example: { word: 'this',   bold: 'th' }, description: 'Voiced dental fricative' },
  's':  { example: { word: 'sit',    bold: 's' },  description: 'Voiceless alveolar fricative' },
  'z':  { example: { word: 'zip',    bold: 'z' },  description: 'Voiced alveolar fricative' },
  'ʃ':  { example: { word: 'ship',   bold: 'sh' }, description: 'Voiceless postalveolar fricative' },
  'ʒ':  { example: { word: 'measure', bold: 's' },  description: 'Voiced postalveolar fricative' },
  'ʂ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiceless retroflex fricative' },
  'ʐ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced retroflex fricative' },
  'ç':  { example: { word: 'hue',    bold: 'h' },  description: 'Voiceless palatal fricative' },
  'ʝ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced palatal fricative' },
  'x':  { example: { word: 'loch (Scottish)', bold: 'ch' }, description: 'Voiceless velar fricative' },
  'ɣ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced velar fricative' },
  'χ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiceless uvular fricative' },
  'ʁ':  { example: { word: '(French rue)', bold: 'r' }, description: 'Voiced uvular fricative' },
  'ħ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiceless pharyngeal fricative' },
  'ʕ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced pharyngeal fricative' },
  'h':  { example: { word: 'hat',    bold: 'h' },  description: 'Voiceless glottal fricative' },
  'ɦ':  { example: { word: 'ahead',  bold: 'h' },  description: 'Voiced glottal fricative' },

  // Lateral Fricatives
  'ɬ':  { example: { word: '(Welsh ll)', bold: 'll' }, description: 'Voiceless alveolar lateral fricative' },
  'ɮ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced alveolar lateral fricative' },

  // Approximants
  'ʋ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced labiodental approximant' },
  'ɹ':  { example: { word: 'red',    bold: 'r' },  description: 'Voiced alveolar approximant' },
  'ɻ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced retroflex approximant' },
  'j':  { example: { word: 'yes',    bold: 'y' },  description: 'Voiced palatal approximant' },
  'ɰ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced velar approximant' },
  'w':  { example: { word: 'wet',    bold: 'w' },  description: 'Voiced labial-velar approximant' },

  // Lateral Approximants
  'l':  { example: { word: 'lip',    bold: 'l' },  description: 'Voiced alveolar lateral approximant' },
  'ɭ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced retroflex lateral approximant' },
  'ʎ':  { example: { word: '(Italian figlio)', bold: 'gli' }, description: 'Voiced palatal lateral approximant' },
  'ʟ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced velar lateral approximant' },

  // ── Non-Pulmonic Consonants ──

  // Clicks
  'ʘ':  { example: { word: '(kiss sound)', bold: '' },     description: 'Bilabial click' },
  'ǀ':  { example: { word: '(tsk-tsk sound)', bold: '' },  description: 'Dental click' },
  'ǃ':  { example: { word: '(tongue pop)', bold: '' },     description: 'Alveolar click' },
  'ǂ':  { example: { word: '(none in English)', bold: '' }, description: 'Palatoalveolar click' },
  'ǁ':  { example: { word: '(giddy-up sound)', bold: '' }, description: 'Alveolar lateral click' },

  // Implosives
  'ɓ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced bilabial implosive' },
  'ɗ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced dental/alveolar implosive' },
  'ʄ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced palatal implosive' },
  'ɠ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced velar implosive' },
  'ʛ':  { example: { word: '(none in English)', bold: '' }, description: 'Voiced uvular implosive' },

  // Ejectives
  'pʼ': { example: { word: '(none in English)', bold: '' }, description: 'Bilabial ejective' },
  'tʼ': { example: { word: '(none in English)', bold: '' }, description: 'Alveolar ejective' },
  'kʼ': { example: { word: '(none in English)', bold: '' }, description: 'Velar ejective' },
  'sʼ': { example: { word: '(none in English)', bold: '' }, description: 'Alveolar fricative ejective' },

  // ── Vowels ──

  'i':  { example: { word: 'see',    bold: 'ee' },  description: 'Close front unrounded vowel' },
  'y':  { example: { word: '(French tu)', bold: 'u' }, description: 'Close front rounded vowel' },
  'ɨ':  { example: { word: 'roses (some dialects)', bold: 'e' }, description: 'Close central unrounded vowel' },
  'ʉ':  { example: { word: 'goose (some dialects)', bold: 'oo' }, description: 'Close central rounded vowel' },
  'ɯ':  { example: { word: '(none in English)', bold: '' }, description: 'Close back unrounded vowel' },
  'u':  { example: { word: 'boot',   bold: 'oo' }, description: 'Close back rounded vowel' },

  'ɪ':  { example: { word: 'bit',    bold: 'i' },  description: 'Near-close near-front unrounded vowel' },
  'ʏ':  { example: { word: '(German hübsch)', bold: 'ü' }, description: 'Near-close near-front rounded vowel' },
  'ʊ':  { example: { word: 'book',   bold: 'oo' }, description: 'Near-close near-back rounded vowel' },

  'e':  { example: { word: 'bay',    bold: 'ay' }, description: 'Close-mid front unrounded vowel' },
  'ø':  { example: { word: '(French peu)', bold: 'eu' }, description: 'Close-mid front rounded vowel' },
  'ɘ':  { example: { word: '(none in English)', bold: '' }, description: 'Close-mid central unrounded vowel' },
  'ɵ':  { example: { word: '(none in English)', bold: '' }, description: 'Close-mid central rounded vowel' },
  'ɤ':  { example: { word: '(none in English)', bold: '' }, description: 'Close-mid back unrounded vowel' },
  'o':  { example: { word: 'go',     bold: 'o' },  description: 'Close-mid back rounded vowel' },

  'ə':  { example: { word: 'about',  bold: 'a' },  description: 'Mid central vowel (schwa)' },

  'ɛ':  { example: { word: 'bed',    bold: 'e' },  description: 'Open-mid front unrounded vowel' },
  'œ':  { example: { word: '(French coeur)', bold: 'oeu' }, description: 'Open-mid front rounded vowel' },
  'ɜ':  { example: { word: 'bird (BrE)', bold: 'ir' }, description: 'Open-mid central unrounded vowel' },
  'ɞ':  { example: { word: '(none in English)', bold: '' }, description: 'Open-mid central rounded vowel' },
  'ʌ':  { example: { word: 'cup',    bold: 'u' },  description: 'Open-mid back unrounded vowel' },
  'ɔ':  { example: { word: 'thought', bold: 'ough' }, description: 'Open-mid back rounded vowel' },

  'æ':  { example: { word: 'cat',    bold: 'a' },  description: 'Near-open front unrounded vowel' },
  'ɐ':  { example: { word: '(none in English)', bold: '' }, description: 'Near-open central vowel' },

  'a':  { example: { word: 'father', bold: 'a' },  description: 'Open front unrounded vowel' },
  'ɶ':  { example: { word: '(none in English)', bold: '' }, description: 'Open front rounded vowel' },
  'ä':  { example: { word: '(none in English)', bold: '' }, description: 'Open central unrounded vowel' },
  'ɑ':  { example: { word: 'palm',   bold: 'a' },  description: 'Open back unrounded vowel' },
  'ɒ':  { example: { word: 'lot (BrE)', bold: 'o' }, description: 'Open back rounded vowel' },
};

export default IPA_TOOLTIPS;
